












































// vendor
import { defineComponent, computed, set, inject } from "@vue/composition-api";
// project
import { ChannelData } from "@/psychlab/types";
import * as SessionAPI from "@/services/api/sessions";
// local
import * as TestTypes from "./test-types";
import CompletedScreen from "./completed-screen.vue";

export default defineComponent({

	emits:[ "end" ],
	props:{
		type:{
			type:String,
			required:true
		},
		parameters:{
			type:Object,
			required:true
		},
		dataNamespace:{
			type:String,
			required:true
		},
		showBack:{
			type:Boolean,
			default:true
		}
	},
	components:{
		CompletedScreen
	},
	setup(props, context){
		const testComponent = computed(() => (TestTypes as any)[props.type]);

		const sessionId = computed(() => context.root.$route.params["sessionId"]);

		const cache = computed(() => context.root.$store.state.cache["storage"]);

		const testValid = computed(() => Boolean(props.type) && Boolean(props.parameters));

		const finished = computed<boolean>({
			get:() => {
				return Boolean(cache.value[`${props.dataNamespace}.finished`]);
			},
			set:v => {
				cacheSessionValue(`${props.dataNamespace}.finished`, v);
			}
		});

		const setProgressStep:any = inject("setProgressStep");

		const cacheSessionValue = (k:string, v:any) => {
			SessionAPI.cacheSessionValue(sessionId.value, k, v);
			context.root.$store.commit("cache/setValue", { k, v });
		};

		const goBack = () => {
			context.emit("back");
		};

		const goForward = () => {
			context.emit("end");
		};

		const restartTest = () => {
			finished.value = false;
		};

		const refreshProgress = () => {
			if(!setProgressStep){ return; }
			setProgressStep(`${props.dataNamespace}`);
		};

		const onEnd = async(data:any) => {
			const channels:ChannelData<any>[] = Object.keys(data).map(k => {
				return {
					key:`${props.dataNamespace}/${k}`,
					data:data[k]
				};
			});

			await SessionAPI.saveDataChannels(sessionId.value, channels);

			context.emit("end");
			finished.value =  true;
		};

		const init = () => {
			refreshProgress();
		};


		init();


		return {
			testComponent,
			finished,
			onEnd,
			restartTest,
			goBack,
			goForward
		};
	}
});

